export default function Footer() {
  return (
    <footer className="bg-[#090c13] text-[#f4f9ff] rounded-window px-18 py-16 mt-24 grid gap-12">
      <h2 className="text-[clamp(3.8rem,6vw+1rem,5.8rem)] font-bold tracking-tighter m-0">
        BankStatementReader
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-11 text-[0.95rem] text-[rgba(228,233,245,0.88)]">
        <div>
          <strong className="block mb-4 text-[rgba(255,255,255,0.85)]">
            Automated statement intelligence
          </strong>
          <p>
            Reduce manual reconciliation, surface anomalies instantly, and deliver audit-ready financial evidence on demand.
          </p>
        </div>

        <div>
          <strong className="block mb-4 text-[rgba(255,255,255,0.85)]">Company</strong>
          <a href="#solutions" className="block mb-2.5 hover:text-accent transition">Solutions</a>
          <a href="#features" className="block mb-2.5 hover:text-accent transition">Features</a>
          <a href="#pricing" className="block mb-2.5 hover:text-accent transition">Pricing</a>
          <a href="#resources" className="block mb-2.5 hover:text-accent transition">Resources</a>
        </div>

        <div>
          <strong className="block mb-4 text-[rgba(255,255,255,0.85)]">Support</strong>
          <a href="/help" className="block mb-2.5 hover:text-accent transition">Help Center</a>
          <a href="/docs/implementation" className="block mb-2.5 hover:text-accent transition">Implementation Guide</a>
          <a href="/security" className="block mb-2.5 hover:text-accent transition">Security</a>
          <a href="/status" className="block mb-2.5 hover:text-accent transition">Status Page</a>
        </div>

        <div>
          <strong className="block mb-4 text-[rgba(255,255,255,0.85)]">Legal</strong>
          <a href="/privacy" className="block mb-2.5 hover:text-accent transition">Privacy Policy</a>
          <a href="/terms" className="block mb-2.5 hover:text-accent transition">Terms of Service</a>
          <a href="/gdpr" className="block mb-2.5 hover:text-accent transition">GDPR Addendum</a>
          <a href="/security/soc2" className="block mb-2.5 hover:text-accent transition">SOC 2 Report</a>
        </div>
      </div>

      <div className="flex justify-between text-[0.85rem] text-[rgba(228,233,245,0.66)]">
        <span>&copy; 2025 BankStatementReader Inc. All rights reserved.</span>
        <span>99.95% Uptime SLA &middot; SOC 2 Type II</span>
      </div>
    </footer>
  )
}
